export const ALL_VALUE = -1;
export const PITCH_TYPES = [{ id: 9 }, { id: 10 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 16 }];
export const RESULT_TYPES = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }];
